import React, { useState } from 'react';

/** "Copy link" for a My Hive post (Jenn, 2026-10-24: to share a contest post in our private Facebook group). */
export const hivePostUrl = (postId) => `${window.location.origin}/dashboard/discussion/${postId}`;

export default function CopyLinkButton({ postId, className = '' }) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    const url = hivePostUrl(postId);
    try { await navigator.clipboard.writeText(url); }
    catch {
      const t = document.createElement('textarea'); t.value = url; document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); } finally { document.body.removeChild(t); }
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return (
    <button type="button" onClick={copy} className={className || 'text-xs font-medium text-gray-400 hover:text-reset-terracotta'}>
      {copied ? '✓ Link copied' : '🔗 Copy link'}
    </button>
  );
}
